import கிளிமூக்கை_உருவாக்கு from '@lassi-js/kilimukku-vue';
import messages from './trads.json';
import {ID_KILIMUKKU_INTERFACE} from '/@/consts';

export default கிளிமூக்கை_உருவாக்கு({
  மொழி: 'fr',
  மூல்_மொழி: 'fr',
  மூல்_மொழிபெயர்ப்புகள்: messages,
  அடையாளம்: ID_KILIMUKKU_INTERFACE,
});
